
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/8-things-to-do-off-the-beaten-track-in-bali",
      function () {
        return require("private-next-pages/blog/8-things-to-do-off-the-beaten-track-in-bali.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/8-things-to-do-off-the-beaten-track-in-bali"])
      });
    }
  